import { css } from 'lit';

export const maximapStyles = css`
  :host {
    position: relative;
  }
  :host([expanded]) {
    color: var(--streamlain-text-secondary-color, #888);
    height: 100%;
    min-height: 0;
    max-height: none;
    border: 0;
    border-radius: 0;
    box-shadow: none;
  }
  canvas {
    touch-action: none;
  }
  .map-control {
    position: absolute;
    z-index: 1;
    top: 8px;
    right: 8px;
    width: 32px;
    height: 32px;
    display: grid;
    place-items: center;
    padding: 0;
    border: 0;
    border-radius: 50%;
    color: var(--streamlain-icon-color);
    background: var(--streamlain-background-primary-color);
    box-shadow: 0 2px 8px #0003;
    cursor: pointer;
  }
  .map-control svg {
    width: 18px;
    height: 18px;
  }
  .map-control:hover {
    color: var(--streamlain-primary-color);
  }
  .map-control:focus-visible,
  canvas:focus-visible {
    outline: 2px solid var(--streamlain-primary-color);
    outline-offset: -2px;
  }
  .maximap-dialog {
    position: fixed;
    inset: auto;
    margin: 0;
    padding: 0;
    border: 0;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
    overflow: hidden;
    max-width: none;
    max-height: none;
  }
  .maximap-dialog[open] {
    display: grid;
    place-items: center;
  }
  .maximap-surface {
    position: relative;
    width: var(--maximap-size);
    height: var(--maximap-size);
  }
  .maximap-dialog::backdrop {
    background: rgb(0 0 0 / 55%);
  }
  .maximap-dialog .map-control {
    top: 12px;
    right: 12px;
    width: 36px;
    height: 36px;
  }
  @media (prefers-reduced-motion: no-preference) {
    .maximap-dialog[open] .maximap-surface {
      animation: reveal-map 180ms ease-out;
    }
    .maximap-dialog[open]::backdrop {
      animation: reveal-map-backdrop 180ms ease-out;
    }
    .maximap-dialog[data-closing] .maximap-surface {
      animation: dismiss-map 180ms ease-in forwards;
      pointer-events: none;
    }
    .maximap-dialog[data-closing]::backdrop {
      animation: dismiss-map-backdrop 180ms ease-in forwards;
    }
    @keyframes reveal-map {
      from {
        opacity: 0;
        transform: scale(0.98);
      }
      to {
        opacity: 1;
        transform: scale(1);
      }
    }
    @keyframes dismiss-map {
      from {
        opacity: 1;
        transform: scale(1);
      }
      to {
        opacity: 0;
        transform: scale(0.98);
      }
    }
    @keyframes reveal-map-backdrop {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
    @keyframes dismiss-map-backdrop {
      from {
        opacity: 1;
      }
      to {
        opacity: 0;
      }
    }
  }
`;
